import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthDataProvider } from 'src/components/authProvider';
import { Layout } from 'src/components/layout';
import { Progress } from 'src/components/progress/Progress';
import { useRumPageTracking } from 'src/hooks/useRumPageTracking';
import { lang } from 'src/utils';

import { useGoogleTagManager } from '../../utils/google-tag-manager';
import { ResourcesProvider } from './ResourcesProvider';

export const PageWrapper = () => {
  const { isLoading, isAuthenticated } = useContext(AuthDataProvider);

  useGoogleTagManager();
  useRumPageTracking();

  if (isLoading) return <Progress />;

  if (!isAuthenticated) {
    return <div>{lang.redirecting}</div>;
  }

  return (
    <ResourcesProvider>
      <Layout>
        <Outlet />
      </Layout>
    </ResourcesProvider>
  );
};
